export const EPIC_STORY_POINT =
	'portfolio-3-plan-increment-common.ui.epic-story-point.epic-story-point';
